import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';

import { history } from '../../../_services/essentials/helpers';
import { userProjectsActions, alertActions, breadcrumbsActions } from '../../../_services/essentials/store';
import { TextField, Button, Stack, Select, MenuItem, FormControl } from '@mui/material';
import Typography from "@mui/material/Typography";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import CancelIcon from "@mui/icons-material/Cancel";
import { ArrowForwardOutlined } from '@mui/icons-material';

import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';
const Card = styled(MuiCard)(({ theme }) => ({
    padding: theme.spacing(3),
    gap: theme.spacing(2),
    margin: 'auto',
    borderRadius: '8px', // Rounded corners
    background: 'var(--Neutral-White, #FFF)', // Background color
    boxShadow: '0px 12px 26px 0px rgba(16, 30, 115, 0.06)', // Floating shadow
    [theme.breakpoints.up('sm')]: {
        width: '40%',
    },
}));

export { AddEdit };

function AddEdit() {

    const entities = 'user_projects';

    // const entity_name = "user_project";
    // const entities_name = "user_projects";
    // const entities_label = "Projects";

    const { id } = useParams();
    const entity_label = "Project";

    const dispatch = useDispatch();
    const entity = useSelector(x => x.userProjects?.item);
    const project_types = useSelector(x => x.userProjects?.project_types);
    const project_statuses = useSelector(x => x.userProjects?.project_statuses);
    //const communication_modes = useSelector(x => x.userProjects?.communication_modes);
    const loggedInUser = useSelector(x => x.auth.loggedInUser);

    // form validation rules

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .trim()
            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
        description: Yup.string()
            .trim()
            .required('Required*')
            .max(250, 'Cannot exceed 250 characters'),
        // type: Yup.object({
        //     id: Yup.string()
        //         .trim()
        //         // .required('Required*')
        //         .notOneOf(['-1'], 'Required*'),
        // }),
        // status: Yup.object({
        //     id: Yup.string()
        //         .trim()
        //         // .required('Required*')
        //         .notOneOf(['-1'], 'Required*'),
        // }),
        geographicScope: Yup.string()
            .trim()
            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
        keywordOrTherapeuticArea: Yup.string()
            .trim()
            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, reset, formState, control } = useForm(formOptions);
    const { errors } = formState;

    dispatch(breadcrumbsActions.setCurrentURL({
        url: history.location?.pathname,
        state: history.location?.state
    }));

    useEffect(() => {
        dispatch(breadcrumbsActions.setCurrentTitle(`Projects`));
        if (id) {
            dispatch(breadcrumbsActions.setCurrentTitle(`Projects`));
            // fetch user details into redux state and 
            // populate form fields with reset()
            dispatch(userProjectsActions.getById(id)).unwrap()
                .then(entity => {
                    reset(entity);
                    //      setUserValue(user);
                });

        } else {
            const newEntity = {
                user: loggedInUser,
                name: "",
                description: "",
                commentAndQuestion: "",
                geographicScope: "",
                communicationMode: { "id": 1 },
                keywordOrTherapeuticArea: "",
                type: { "id": 1 },
                status: { "id": 1 },
            };
            dispatch(userProjectsActions.getNewEntity(newEntity)).unwrap()
                .then(entity => {
                    reset(entity);
                    //      setUserValue(user);
                });

            dispatch(breadcrumbsActions.setCurrentTitle(`Projects`));
        }
    }, [id, dispatch, reset, loggedInUser]);

    useEffect(() => {
        dispatch(userProjectsActions.getAllProjectTypes());
        dispatch(userProjectsActions.getAllProjectStatuses());
        //dispatch(userProjectsActions.getAllCommunicationModes());
    }, [dispatch]);

    async function onSubmit(data) {
        dispatch(alertActions.clear());
        //alert('Updated Data: '+JSON.stringify(data));
        try {
            // create or update user based on id param
            let message;
            if (id) {
                await dispatch(userProjectsActions.update({ id, data })).unwrap();
                //TODO: Make use of return value. and display message based on return value
                message = `${entity_label} details has been updated successfully `;
            } else {
                // const response = await dispatch(userProjectsActions.create({ data })).unwrap();
                await dispatch(userProjectsActions.create({ data })).unwrap();
                // dispatch(alertActions.error(response));
                //TODO: Make use of return value. and display message based on return value
                //message = response.message;
                message = `${entity_label} details has been Added successfully`;
                //message = 'User added';
            }

            // redirect to user list with success message
            history.navigate(`/${entities}`);
            dispatch(alertActions.success({ message, showAfterRedirect: true }));
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    return (
        <React.Fragment>
            <Card sx={{
                ml: 2
            }}>
                <Stack
                    sx={{
                        justifyContent: 'space-between', flexGrow: '1', gap: 1, alignItems: 'center'
                    }}
                >
                    {/* <Typography component="h2" variant="h6" sx={{ mb:1.5 }}>
                    {entity_label}
                </Typography> */}
                    {!(entity?.loading || entity?.error) &&
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Stack direction="column" sx={{ flexGrow: '1', gap: 1 }}>
                                {/*<Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >*/}
                                {/*    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Full Name*/}
                                {/*    </Typography>*/}
                                {/*    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Email Address</Typography>*/}
                                {/*</Stack>*/}
                                {/*<Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >*/}
                                {/*    <TextField*/}
                                {/*        id="fullName"*/}
                                {/*        name="fullName"*/}
                                {/*        type="text"*/}
                                {/*        variant='outlined'*/}
                                {/*        color='primary'*/}
                                {/*        // label="Full Name"*/}
                                {/*        placeholder={""}*/}
                                {/*        autoComplete="off"*/}
                                {/*        fullWidth*/}
                                {/*        sx={{ mb: 1.5 }}*/}
                                {/*        // inputlabelprops={{ shrink: true }}*/}
                                {/*        value={`${entity?.value?.user?.firstname} ${entity?.value?.user?.lastname}`}*/}
                                {/*        readOnly*/}
                                {/*    />*/}
                                {/*    <TextField*/}
                                {/*        id="user.email"*/}
                                {/*        name="user.email"*/}
                                {/*        type="text"*/}
                                {/*        variant='outlined'*/}
                                {/*        color='primary'*/}
                                {/*        // label="Email Address"*/}
                                {/*        placeholder={""}*/}
                                {/*        autoComplete="off"*/}
                                {/*        fullWidth*/}
                                {/*        sx={{ mb: 1.5, }}*/}
                                {/*        inputlabelprops={{ shrink: true }}*/}
                                {/*        value={entity?.value?.user?.email}*/}
                                {/*        readOnly*/}
                                {/*    />*/}
                                {/*</Stack>*/}
                                {/*<Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >*/}
                                {/*    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Phone Number*/}
                                {/*    </Typography>*/}
                                {/*    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Preferred Contact Method</Typography>*/}
                                {/*</Stack>*/}
                                {/*<Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >*/}
                                {/*    <TextField*/}
                                {/*        id="user.phone"*/}
                                {/*        name="user.phone"*/}
                                {/*        type="text"*/}
                                {/*        variant='outlined'*/}
                                {/*        color='primary'*/}
                                {/*        // label="Phone Number"*/}
                                {/*        placeholder={""}*/}
                                {/*        autoComplete="off"*/}
                                {/*        fullWidth*/}
                                {/*        sx={{ mb: 1.5 }}*/}
                                {/*        inputlabelprops={{ shrink: true }}*/}
                                {/*        value={entity?.value?.user?.phone}*/}
                                {/*        readOnly*/}
                                {/*    />*/}
                                {/*    {!(communication_modes?.loading || communication_modes?.error) &&*/}
                                {/*        <FormControl fullWidth>*/}
                                {/*            /!* <InputLabel id="select-communication_modes-label">Preferred Contact Method</InputLabel> *!/*/}
                                {/*            <Select*/}
                                {/*                labelId="select-communication_modes-label"*/}
                                {/*                id="communication_modes.id"*/}
                                {/*                name="communication_modes.id"*/}
                                {/*                // label="Preferred Contact Method"*/}
                                {/*                defaultValue={entity?.value?.communicationMode.id || "-1"}*/}
                                {/*                {...register('communicationMode.id')}*/}
                                {/*                sx={{*/}
                                {/*                    mb: 1.5, border: 0, height: '40px', maxWidth: '350px', backgroundColor: '#fff', '&:hover': {*/}
                                {/*                        backgroundColor: '#fff'*/}
                                {/*                    },*/}
                                {/*                }}*/}
                                {/*            >*/}
                                {/*                <MenuItem key={-1} value={-1}>-Select-</MenuItem>*/}
                                {/*                {communication_modes?.value?.map((communicationMode) => (*/}
                                {/*                    <MenuItem key={communicationMode.id} value={communicationMode.id}>{communicationMode.name}</MenuItem>*/}
                                {/*                ))}*/}
                                {/*            </Select>*/}
                                {/*        </FormControl>*/}
                                {/*    }*/}
                                {/*</Stack>*/}
                                {/*<Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >*/}
                                {/*    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Company Name*/}
                                {/*    </Typography>*/}
                                {/*    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Company Website</Typography>*/}
                                {/*</Stack>*/}
                                {/*<Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >*/}
                                {/*    <TextField*/}
                                {/*        id="user.customer.organizationName"*/}
                                {/*        name="user.customer.organizationName"*/}
                                {/*        type="text"*/}
                                {/*        variant='outlined'*/}
                                {/*        color='primary'*/}
                                {/*        // label="Company Name"*/}
                                {/*        placeholder={""}*/}
                                {/*        autoComplete="off"*/}
                                {/*        fullWidth*/}
                                {/*        sx={{ mb: 1.5 }}*/}
                                {/*        inputlabelprops={{ shrink: true }}*/}
                                {/*        value={entity?.value?.user?.customer.organizationName}*/}
                                {/*        readOnly*/}
                                {/*    />*/}
                                {/*    <TextField*/}
                                {/*        id="user.customer.websiteURL"*/}
                                {/*        name="user.customer.websiteURL"*/}
                                {/*        type="text"*/}
                                {/*        variant='outlined'*/}
                                {/*        color='primary'*/}
                                {/*        // label="Company Website"*/}
                                {/*        placeholder={""}*/}
                                {/*        autoComplete="off"*/}
                                {/*        fullWidth*/}
                                {/*        sx={{ mb: 1.5 }}*/}
                                {/*        inputlabelprops={{ shrink: true }}*/}
                                {/*        value={entity?.value?.user?.customer.websiteURL}*/}
                                {/*        readOnly*/}
                                {/*    />*/}
                                {/*</Stack>*/}
                                <Stack direction="column" sx={{ flexGrow: '1', gap: 1 }} >
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Project Name<span style={{ color: 'red' }}>*</span></Typography>
                                </Stack>
                                <Stack direction="column" sx={{ flexGrow: '1', gap: 1 }} >
                                    <TextField
                                        id="name"
                                        name="name"
                                        type="text"
                                        variant='outlined'
                                        color='primary'
                                        // label="Inquiry Details"
                                        placeholder={""}
                                        autoComplete="off"
                                        fullWidth
                                        sx={{ mb: 1.5 }}
                                        inputlabelprops={{ shrink: true }}
                                        defaultValue={entity?.value?.name}
                                        {...register('name', { required: true })}
                                        error={Boolean(errors.name)}
                                        helperText={errors.name ? errors.name.message : ""}
                                        inputProps={{
                                            maxLength: 60,
                                        }}
                                    />
                                    <TextField
                                        id="commentAndQuestion"
                                        name="commentAndQuestion"
                                        type="text"
                                        variant='outlined'
                                        color='primary'
                                        // label="Additional Comments or Questions"
                                        placeholder={""}
                                        autoComplete="off"
                                        fullWidth
                                        hidden
                                        sx={{ mb: 1.5 }}
                                        inputlabelprops={{ shrink: true }}
                                        defaultValue={entity?.value?.commentAndQuestion}
                                        {...register('commentAndQuestion')}
                                    />
                                </Stack>
                                <Stack direction="column" sx={{ flexGrow: '1', gap: 1 }} >
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Project Description<span style={{ color: 'red' }}>*</span></Typography>
                                </Stack>
                                <Stack direction="column" sx={{ flexGrow: '1', gap: 1 }} >
                                    <TextField
                                        id="description"
                                        name="description"
                                        variant='outlined'
                                        color='primary'
                                        // label="Inquiry Description"
                                        placeholder={""}
                                        autoComplete="off"
                                        fullWidth
                                        multiline
                                        size="normal"
                                        rows={3}
                                        sx={{
                                            mb: 1.5,
                                            '& .MuiInputBase-root': {
                                                height: 'auto',
                                                // maxWidth: '97%'
                                            },
                                        }}
                                        inputlabelprops={{ shrink: true }}
                                        defaultValue={entity?.value?.description}
                                        {...register('description', { required: true })}
                                        error={Boolean(errors.description)}
                                        helperText={errors.description ? errors.description.message : ""}
                                        inputProps={{
                                            maxLength: 250,
                                        }}
                                    />
                                </Stack>
                                <Stack direction="column" sx={{ flexGrow: '1', gap: 1 }} >
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Service Provided</Typography>
                                </Stack>
                                <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >

                                    <FormControl fullWidth>
                                        {!(project_types?.loading || project_types?.error) &&
                                        <Controller
                                            name="type.id"
                                            control={control}
                                            defaultValue={entity?.value?.type?.id || "-1"}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    labelId="select-type.id-label"
                                                    id="type.id"
                                                    name="type.id"
                                                    sx={{
                                                        mb: 1.5,
                                                        border: 0,
                                                        height: '40px',
                                                        maxWidth: '350px',
                                                        backgroundColor: '#fff',
                                                        '&:hover': {
                                                            backgroundColor: '#fff',
                                                        },
                                                    }}
                                                >
                                                    {/*<MenuItem key={-1} value={-1}>*/}
                                                    {/*    -Select-*/}
                                                    {/*</MenuItem>*/}
                                                    {project_types?.value?.map((type) => (
                                                        <MenuItem key={type.id} value={type.id}>
                                                            {type.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            )}
                                        />
                                        }
                                    </FormControl>
                                </Stack>
                                <Stack direction="column" sx={{ flexGrow: '1', gap: 1 }} >
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Keyword or Therapeutic Area<span style={{ color: 'red' }}>*</span></Typography>
                                </Stack>
                                <Stack direction="column" sx={{ flexGrow: '1', gap: 1 }} >
                                    <TextField
                                        id="keywordOrTherapeuticArea"
                                        name="keywordOrTherapeuticArea"
                                        type="text"
                                        variant='outlined'
                                        color='primary'
                                        // label="Keyword or Therapeutic Area"
                                        placeholder={""}
                                        autoComplete="off"
                                        fullWidth
                                        sx={{ mb: 1.5 }}
                                        inputlabelprops={{ shrink: true }}
                                        defaultValue={entity?.value?.keywordOrTherapeuticArea}
                                        {...register('keywordOrTherapeuticArea', { required: true })}
                                        error={Boolean(errors.keywordOrTherapeuticArea)}
                                        helperText={errors.keywordOrTherapeuticArea ? errors.keywordOrTherapeuticArea.message : ""}
                                        inputProps={{
                                            maxLength: 60,
                                        }}
                                    />
                                </Stack>
                                <Stack direction="column" sx={{ flexGrow: '1', gap: 1 }} >
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Geographic Scope<span style={{ color: 'red' }}>*</span></Typography>
                                </Stack>
                                <Stack direction="column" sx={{ flexGrow: '1', gap: 1 }} >
                                    <TextField
                                        id="geographicScope"
                                        name="geographicScope"
                                        type="text"
                                        variant='outlined'
                                        color='primary'
                                        // label="Geographic Scope"
                                        placeholder={""}
                                        autoComplete="off"
                                        fullWidth
                                        sx={{ mb: 1.5 }}
                                        inputlabelprops={{ shrink: true }}
                                        defaultValue={entity?.value?.geographicScope}
                                        {...register('geographicScope', { required: true })}
                                        error={Boolean(errors.geographicScope)}
                                        helperText={errors.geographicScope ? errors.geographicScope.message : ""}
                                        inputProps={{
                                            maxLength: 60,
                                        }}
                                    />
                                </Stack>
                                {id && <>
                                    <Stack direction="column" sx={{ flexGrow: '1', gap: 1 }} >
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Status</Typography>
                                </Stack>
                                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >

                                        <FormControl fullWidth>
                                            {/* <InputLabel id="select-status.id-label">Status</InputLabel> */}
                                            {!(project_statuses?.loading || project_statuses?.error) &&
                                                <Controller
                                                    name="status.id"
                                                    control={control}
                                                    defaultValue={entity?.value?.status?.id || "-1"}
                                                    render={({ field }) => (
                                                        <Select
                                                            {...field}
                                                            labelId="select-status.id-label"
                                                            id="status.id"
                                                            name="status.id"
                                                            sx={{
                                                                mb: 1.5,
                                                                border: 0,
                                                                height: '40px',
                                                                maxWidth: '350px',
                                                                backgroundColor: '#fff',
                                                                '&:hover': {
                                                                    backgroundColor: '#fff',
                                                                },
                                                            }}
                                                        >
                                                        {/*<MenuItem key={-1} value={-1}>*/}
                                                        {/*    -Select-*/}
                                                        {/*</MenuItem>*/}
                                                            {project_statuses?.value?.map((status) => (
                                                                <MenuItem key={status.id} value={status.id}>
                                                                    {status.name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    )}
                                                />
                                            }
                                        </FormControl>
                                    </Stack>
                                </>
                                }
                                <Stack direction="row" sx={{ flexGrow: '1', gap: 1, alignItems: 'center' }} >
                                    <Stack direction="row" spacing={1} sx={{ mt: 0.5 }} >
                                        <Button type={"submit"} variant="contained" size="small" endIcon={<ArrowForwardOutlined />}>
                                            Save
                                        </Button>
                                        <Button onClick={() => reset()} variant="outlined" size="small" endIcon={<SettingsBackupRestoreIcon />}>
                                            Reset
                                        </Button>
                                        <Button onClick={() => history.navigate(-1)} variant="outlined" size="small" endIcon={<CancelIcon />}>
                                            Cancel
                                        </Button>
                                    </Stack>
                                </Stack>

                            </Stack>
                        </form>
                    }
                </Stack>
            </Card>
        </React.Fragment>
    );
}
